module.exports = __webpack_public_path__ + "static/media/max-k-20.b60c5ff3.png";